import { RouterProvider } from 'react-router-dom';
import { Providers } from './providers.js';
import { router } from './router.js';

/** Root application: providers wrap the RR v6 router. */
export function App() {
  return (
    <Providers>
      <RouterProvider router={router} />
    </Providers>
  );
}
